import * as React from "react";

const SvgThread = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    {...props}
  >
    <circle cx={12.5} cy={12.5} r={12.5} fill="#000" />
    <path
      fill="#fff"
      d="M17.229 12.158a7 7 0 0 0-.26-.117c-.152-2.81-1.688-4.42-4.266-4.436h-.035c-1.542 0-2.825.658-3.615 1.856l1.418.973c.59-.895 1.516-1.086 2.197-1.086h.024c.849.006 1.49.253 1.904.734.302.35.504.835.604 1.446a11 11 0 0 0-2.437-.117c-2.452.14-4.028 1.57-3.922 3.557.054 1.008.556 1.875 1.414 2.441.725.48 1.66.713 2.63.66 1.282-.07 2.288-.56 2.99-1.454.532-.679.87-1.56 1.018-2.668.611.369 1.064.854 1.314 1.437.425.992.45 2.621-.88 3.95-1.164 1.163-2.565 1.667-4.68 1.682-2.348-.017-4.123-.77-5.278-2.237-1.08-1.374-1.64-3.359-1.66-5.9.02-2.54.58-4.524 1.66-5.898 1.155-1.467 2.93-2.22 5.277-2.238 2.365.018 4.171.774 5.37 2.249.587.723 1.03 1.632 1.322 2.692L21 9.241c-.354-1.305-.911-2.43-1.67-3.362C17.795 3.989 15.548 3.02 12.653 3h-.011c-2.89.02-5.112.992-6.604 2.89C4.708 7.578 4.023 9.928 4 12.873v.014c.023 2.945.708 5.294 2.037 6.983 1.492 1.897 3.714 2.87 6.603 2.89h.012c2.569-.018 4.38-.69 5.871-2.18 1.952-1.95 1.893-4.394 1.25-5.895-.462-1.076-1.341-1.95-2.544-2.527m-4.436 4.17c-1.074.06-2.19-.421-2.246-1.454-.04-.766.545-1.62 2.312-1.723q.303-.017.596-.017c.642 0 1.242.062 1.788.182-.204 2.542-1.398 2.955-2.45 3.012"
    />
  </svg>
);
export default SvgThread;